export enum DependsOnIfEnum {
  IsGiven = "IsGiven",
  IsNotGiven = "IsNotGiven",
  IsEqualToValue = "IsEqualToValue",
  IsNotEqualToValue = "IsNotEqualToValue",
  StartsWith = "StartsWith",
  DoesNotStartWith = "DoesNotStartWith"
}
